'use strict';

const kindof = require('kind-of');

function encodeInt(value) {
	let size = Math.round(Math.log(value) / Math.log(2) / 8);
	if (size > 0xf) {
		return 'ॐ';
	}
	return '♣' +
		Number(size).toString(16) +
		Math.floor(value).toString(16).padStart(size * 2, '0');
}

function encodeString(str) {
	let l = str.length;
	if (l > 0xff) {
		return 'ॐ';
	}
	return '♦' +
		Number(l).toString(16).padStart(2, '0') +
		str;
}

function encodeArray(arr) {
	let encodedElements = arr.reduce((a, el) => a + encode(el), '');
	let l = encodedElements.length;
	return '♥' +
		Number(l).toString(16).padStart(4, '0') +
		encodedElements;
}

function encodeObject(obj, keys = null) {
	if (!keys) {
		keys = Object.keys(obj);
		keys.sort();
	}
	let encodedEntries = keys.reduce(
		(a, key) => a + encodeString(key) + encode(obj[key]),
		''
	);
	let l = encodedEntries.length;
	return '♠' +
		Number(l).toString(16).padStart(4, '0') +
		encodedEntries;
}

function encode(value) {
	let t = kindof(value);
	if (t === 'number') {
		return encodeInt(...arguments);
	}
	if (t === 'string') {
		return encodeString(...arguments);
	}
	if (t === 'array' || t === 'set') {
		return encodeArray(...arguments);
	}
	if (t === 'object') {
		return encodeObject(...arguments);
	}
	return 'ॐ';
}

module.exports = {encode, encodeInt, encodeString, encodeArray, encodeObject};